<template>
  <div id="container">
      <h3 class="content-block openware-form-title">{{ title }}</h3>
      <DxPopup
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-close-button="true"
          :show-title="true"
          v-model:visible="isPopupVisible"
          title="Γεωγραφική Τοποθεσία"
          :width="'90%'" 
          :height="'90%'"
          :toolbar-items="[
                          {
                              widget: 'dxButton',
                              location: 'after',
                              options: {
                                  icon: 'help', 
                                  onClick: () => {
                                      this.isPopoverVisible = !this.isPopoverVisible;
                                  },
                                  elementAttr: {
                                      id: 'help-button'
                                  }
                              }
                          }
                      ]"
          deferRendering="true"
          :animation="{
                        show: {
                            type: 'pop',
                            duration: 800,
                            from: {
                                scale: 0.90
                            }
                        }, 
                      }"
      >
          <DxScrollView height="100%" width="100%">
              <GeoLocationForm 
                  :geo_location_id="selectedGeoLocationID" 
                  @closePopupEvent="onClosePopupEmit">
              </GeoLocationForm>
          </DxScrollView>
      </DxPopup>
          
      <DxDataGrid
          :key-expr="id"
          :data-source="CustomStoreMain"
          :toolbar="toolbarOptions"
          :columns="columns"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          :show-column-lines="true"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :selection-mode="'single'"
          :ref="dataGridRefKey"
          :word-wrap-enabled="true"

          @exporting="onExporting"
          @selectionChanged="onSelectionChanged"
          @init-new-row="onCustomInitNewRow"
      >
          <DxSelection mode="single" />
          <DxEditing
              :allow-updating="true"
              :allow-adding="true"
              :allow-deleting="true"
          />
          <DxToolbar>
              <DxItem location="after" 
                      widget="dxButton" 
                      :options="{
                          icon: 'add',
                          text: '',
                          hint: 'Προσθήκη',
                          onClick: () => {
                              this.onCustomInitNewRow()
                          }
                      }"

              />
              <DxItem name="exportButton" 
                  :options="{
                          hint: 'Εξαγωγή δεδομένων'

                      }"
                />
          </DxToolbar>

          <DxPaging 
              :enabled="true"
              :page-size="5"
          />

          <DxFilterRow :visible="true"/>
          <DxHeaderFilter :visible="true"/>
          
          <DxPager
              :visible="true"
              :allowed-page-sizes="pageSizes"
              :display-mode="displayMode"
              :show-page-size-selector="true"
              :show-info="true"
              :show-navigation-buttons="true"
          />

          <DxGroupPanel :visible="false"/>

          <DxSorting mode="multiple"/>

          <DxColumn
              data-field="parent_geo_location_id"
              caption="Γεωγραφική Περιοχή"
              sort-order="asc"
          >
              <DxLookup
                  :data-source="LookupCustomDS_serres_geo_locations" 
                  value-expr="geo_location_id"
                  display-expr="descr"
              />
          </DxColumn>

          <DxColumn
              data-field="descr_lang"
              caption="Περιγραφή Τοποθεσίας"
          >
          </DxColumn>

          <DxColumn
              data-field="short_descr"
              caption="Συντομογραφία Τοποθεσίας"
          >
          </DxColumn>

          <DxColumn
              data-field="priority_ind"
              caption="Προτεραιότητα "
          >
          </DxColumn>

          <DxColumn type="buttons">
              <DxButton 
                  text="Επεξεργασία"
                  icon="edit"
                  hint="Επεξεργασία"
                  :on-click="onCustomRowEdit"
              />
              <DxButton name="delete" hint="Διαγραφή"/>
          >
          </DxColumn>

          <DxExport
              :enabled="true"
              :formats="['pdf', 'xlsx']"
              :texts= "{
                      exportAll: 'Εξαγωγή σε {0}',
                  }"
          />

      </DxDataGrid>
  </div>
</template>

<script>

const DATAGRIDREFKEY = 'my-data-grid';

const URL_SERVICE = NYParameters.Host.URI + 'serres_geo_locations_VIEW';
const URL_SERVICE_LOOKUP_serres_geo_locations = NYParameters.Host.URI + 'serres_geo_locations';

import DxDataGrid, {
  DxColumn,
  DxButton,
  DxEditing, 
  DxPaging,
  DxPager,
  DxGroupPanel,
  DxSorting,
  DxFilterRow,
  DxHeaderFilter,
  DxExport,
  DxSelection,
  DxLookup,
  DxToolbar,
  DxItem
} from 'devextreme-vue/data-grid';

import DxScrollView from 'devextreme-vue/scroll-view';
import DxPopup from 'devextreme-vue/popup';

import CustomStore from 'devextreme/data/custom_store';
import 'whatwg-fetch';

import GeoLocationForm from './ny-geo-locations-form.vue';

import NYParameters from '../../ny-globals';

export default {
      components: {
        GeoLocationForm,

        DxDataGrid,
        DxColumn,
        DxButton,
        DxEditing, 
        DxPaging,
        DxPager,
        DxGroupPanel,
        DxSorting,
        DxFilterRow, 
        DxHeaderFilter,
        DxExport,
        DxPopup,
        DxLookup,
        DxScrollView,
        DxSelection,
        DxToolbar,
        DxItem,
  },
  data() {
      return {
          IPPattern: "^((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)\\.?\\b){4}$",
          CustomStoreMain: new CustomStore({
              key: 'geo_location_id',
              //loadMode: 'raw',
              load: () => this.sendRequest(URL_SERVICE),
              insert: (values) => this.sendRequest(URL_SERVICE, 'POST', values),
              update: (key, values) => this.sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
              remove: (key) => this.sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
              byKey: (key) => this.sendRequest(URL_SERVICE + "/" + encodeURIComponent(key)),
          }),

          LookupCustomDS_serres_geo_locations:  new CustomStore({
              key: 'geo_location_id',
              loadMode: 'raw',
              load: () => this.sendRequest(URL_SERVICE_LOOKUP_serres_geo_locations),
          }),

          isPopupVisible: false,
          isPopoverVisible: false,

          title: 'Γεωγραφικές Τοποθεσίες',
          pageSizes: [5, 10, 20],
          dataGridRefKey: DATAGRIDREFKEY,
          toolbarOptions: {
              items: [
                  {
                      widget: 'dxButton',
                      options: {
                          icon: 'add',
                          text: 'Προσθηκη',
                          onClick: () => {
                              this.onCustomInitNewRow()
                          }
                      }
                  }
              ]
          }
      };
  }, 
  
  methods: {
      // 
      //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
      //
      sendRequest(url, method = 'GET', values = {}) {
          // console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          if (method === 'GET') {
              return fetch(url, {
                  method,
                  credentials: 'include',
              })
              .then((response) => response.json()
              .then((json) => {
                  if (response.ok) return json.records;
                  throw json.Message;
              }));
          }
          return fetch(url, {
              method,
              body: JSON.stringify(values),
              headers: {
                  'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
              },
              credentials: 'include',
          }).then((result) => {
              if (result.ok) {
                  return result.text().then((text) => text && JSON.parse(text));
              }
              return result.json().then((json) => {
                  throw json.Message;
              });
          });
      },
      onSelectionChanged(e) {
          this.selectedGeoLocationID = e.currentSelectedRowKeys[0];
      },
      onClosePopupEmit() {
          this.isPopupVisible = false;
          this.dataGrid.refresh();
      },
      onOpenForm(e) {
        this.$refs.form.open(e.data);
      },
      onCustomInitNewRow() {
          this.isPopupVisible = true;
          this.selectedGeoLocationID = null;
      },
      onCustomRowEdit(e) {
          this.selectedGeoLocationID = e.row.key;
          this.isPopupVisible = true;
      },
      onExporting (e){
          NYParameters.methods.exportDataGridToPdfExcel(e, this.title)
      },
  },
  computed: {
      dataGrid: function() {
          return this.$refs[DATAGRIDREFKEY].instance;
      }
  },
};
</script>

<style lang="scss">
</style>
